module.exports = __webpack_public_path__ + "img/IMG-20200919-WA0126.f990cf25.jpg";